import { render, staticRenderFns } from "./DouobIcon.vue?vue&type=template&id=ae92aba8&scoped=true&"
import script from "./DouobIcon.vue?vue&type=script&lang=js&"
export * from "./DouobIcon.vue?vue&type=script&lang=js&"
import style0 from "./DouobIcon.vue?vue&type=style&index=0&id=ae92aba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae92aba8",
  null
  
)

export default component.exports